const E = {
  SearchPlaceholder: 'Item Name, Type, etc.',
  Recommended: 'Recommended',
  'All Categories': 'All',
  AvailableSupplies: 'Available Supplies',
  OrderAdditionalSupplies: 'Order Additional Supplies',
  YourFavourites: 'Your Favourites',
  YourSuppliesSummary: 'Your Supplies Summary',
  View: 'View',
  Size: 'Size',
  Type: 'Type',
  Preservative: 'Preservative',
  AddToCart: 'Add to Cart',
  AddToOrder: 'Add to Order',
  RemoveFromCart: 'Remove from Cart',
  RemoveFromOrder: 'Remove from Order',
  Quantity: 'Quantity',

  Filters: 'Filters',
  Water: 'Water / Liquids',
  Food: 'Food',
  Soil: 'Soil / Solids',
  Coolers: 'Coolers',
  General: 'General',
  Preservatives: 'Preservatives',
  Item: 'Item',
  AdditionalSuppliesModal:
    'Your supply order will be prepared based on the tests and samples selected and will include standard supplies such as a cooler and bubble wrap (as applicable).\n\n Would you like to include additional supplies in your order?',
  AdditionalSuppliesModalYes: 'add more supplies',
  AdditionalSuppliesModalNo: 'view order summary',
  noRecemmendedSupplies: 'There are no recommendations at this time.',
};

const F = {
  SearchPlaceholder: "Nom de l'article, type, etc.",
  'All Categories': 'Toutes',
  Recommended: 'Conseillé',
  AvailableSupplies: 'Matériel disponible',
  OrderAdditionalSupplies: 'Commander du matériel supplémentaire',
  YourFavourites: 'Vos favoris',
  YourSuppliesSummary: 'Résumé de votre matériel',
  View: 'Visualiser',
  Type: 'Type',
  Preservative: 'Agent de Conservation',
  AddToCart: 'Ajouter au panier',
  AddToOrder: 'Ajouter au panier',
  RemoveFromCart: 'Retirer du panier',
  RemoveFromOrder: 'Retirer du panier',
  Quantity: 'Quantité',

  Filters: 'Les filtres',
  Water: 'Eau / Liquides',
  Food: 'Aliments',
  Soil: 'Sol / Solides',
  Coolers: 'Glacières',
  General: 'Générale',
  Size: 'Format',
  Preservatives: 'Préservatif',
  Item: 'Item',
  AdditionalSuppliesModal:
    'Le matériel sera préparé en fonction des analyses et des échantillons sélectionnés et comprendra le matériel de base, soit une glacière et du papier bulle (le cas échéant). Voulez-vous ajouter du matériel supplémentaire à votre commande ?',
  AdditionalSuppliesModalYes: 'ajouter du matériel',
  AdditionalSuppliesModalNo: 'résumé de la commande',
  noRecemmendedSupplies: `Il n'y a pas de recommandations pour le moment.`,
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsSupplies.js